import { Documents } from "src/ui/fragments";

export const Section6 = () => {
  return <Documents isLandingPage />;
};
